import { Avatar as EtAvatar } from "@ever-tutor/et-ui";

const Avatar = ({ src, alt }: { src: string; alt: string }) => {
  const defaultAvatar = "/assets/default-profile.svg";
  const imageSrc = src && src.trim() !== "" ? src : defaultAvatar;

  return (
    <EtAvatar
      src={imageSrc}
      alt={alt}
      size="md"
      aria-label={alt || "User Avatar"}
    />
  );
};

export default Avatar;
